/**
* adding an additional method to the base prototype model for calling our server - since we're not using a
* RESTful interface and we want to be able to cancel stuff.
* 
* @example
* 
* UserDocs.remote(
*	"userdocumentdelete", //your event name and nothing else
*	{DOCUMENTID: this.id}, //your data as an object
* );
* 
* @class 	
*
* @param 	{String} 		event		the Coldfusion event - only event is sent so we can change this method to post the event if needed!
* @param 	{Object} 		data 		A data object to send in the POST request
* 
*/

UserDocs.remote = function(event, data, message) {

    let checkLoggedIn = false,
        ajaxLoading = $('.e_ajax_loading').fadeIn();

    $('html').addClass("e_body_ajax_loading");

    //headers
    let headers = new Headers({
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    });

    //set up timeouts on fetch
    const controller = new AbortController();
    const signal = controller.signal;

    setTimeout(() => controller.abort(), 600000);//10 minute timeout for JCT exports!

    //sort out the data package. Needs the session token. Needs to be
    //formatted as form fields
    data = data ? data : {};
    data["_t"] = ele.config.usersession._t;
    let formData = new FormData();
    for (let key in data) {
        formData.append(key, data[key]);
    }
    //go
    return fetch(ele.uri.buildUrl(event, {ajax:1}),
        {
            method: data ? "POST" : "GET",
            body: formData,
            signal: signal
        }
    ).then(response => {
        if(!response.ok) {
            if(response.status === 404) throw new Error("Not found")
            else if(response.status === 401) throw new Error("Unauthorized")
            else if(response.status === 403) throw new Error("Unauthorized")
            else throw new Error("Other error")
        }
        else {
            ajaxLoading.fadeOut();
            $('html').removeClass("e_body_ajax_loading");
            return response;
        }
    }).then(response => {
        return response.json(); //response is now the json returned from server
    }).catch(e => {
        $('html').removeClass("e_body_ajax_loading");
        if (e.message == "Unauthorized") {
            let modal = ele.modal.confirm("<p>" + i18n("js_save_failed_long") + "</p>",
                function () {
                    document.location.reload(true);
                }
            );
            modal.parent().find('.e_cancel').hide();
        } else if (e.message.indexOf("abort") > -1 || e.message.indexOf("Failed to fetch") > -1) {
            let modal = ele.modal.confirm("<h3>" + i18n('js_timout') + "</h3><p>" + i18n('js_timout_c') + "</p>");
            modal.parent().find('.e_cancel').hide();
        } else if(message){
            console.log(message);
            let modal = ele.modal.confirm("<h3>" + e.message + "</h3><p>" + message + "</p>");
            modal.parent().find('.e_cancel').hide();
        }
        throw e;
    });

};

//additionally need to handle the AJAX requests handled by Backbone. There's no way to tap into these, so wither create
// a custom Model and Collection base class to extend from or set the option via the global jQuery AJAX config
$.ajaxSetup({
    cache: false,
    statusCode: {
        401: function () {
            let modal = ele.modal.confirm("<p>" + i18n("js_save_failed_long") + "</p>",
                function() {
                    document.location.reload(true);
                }
            );
            modal.parent().find('.e_cancel').hide();
        }
    }
});